<template>
  <el-drawer :visible.sync="drawer" :with-header="false" size="860px" >
    <div class="join-inquiry-list-drawer">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="close"></i>
      </div>
      <div class="join-inquier-list-product">
        <div class="item-box-add">
          <el-row>
            <el-col :span="18">
              <span class="title-font-style" v-if='type === 1'>客户余额明细</span>
              <span class="title-font-style" v-else>供应商余额明细</span>

            </el-col>
            <el-col :span="6" style="text-align:right">
              <el-button>导出</el-button>
            </el-col>
          </el-row>
          <el-form class="add-content details-line-height" style="padding:0 30px;">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="客户编号：">
                 <span>{{rows.cusCode}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客户名称：">
                  <span>{{rows.cusName}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="账户余额：">
                  <span>{{rows.accountBalance|priceFilterNum}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="可提现余额：">
                  <span>{{rows.withdrawCash |priceFilterNum}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div :style="{height:tableHeight+'px'}">
          <el-table
            border
            ref="tableRef"
            tooltip-effect="dark"
            :data="list"
            :max-height="tableHeight"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
           >
            <el-table-column label="交易时间">
              <template slot-scope="scope">
                <div>{{scope.row.number |dateFilter}}</div>
              </template>
            </el-table-column>
            <el-table-column label="交易金额">
              <template slot-scope="scope">
                <div v-if='scope.row.number < 0' style='color:#D35E5E'></div>
                <div v-else>{{scope.row.number |priceFilterNum}}</div>
              </template>
            </el-table-column>
            <el-table-column label="变更前账户余额" width="120">
              <template slot-scope="scope">
                <div>{{scope.row.number |priceFilterNum}}</div>
              </template>
            </el-table-column>
            <el-table-column label="变更后账户余额" width="120">
              <template slot-scope="scope">
                <div>{{scope.row.number |priceFilterNum}}</div>
              </template>
            </el-table-column>
            <el-table-column label="变更前可提现余额" width="140">
              <template slot-scope="scope">
                <div>{{scope.row.number |priceFilterNum}}</div>
              </template>
            </el-table-column>
            <el-table-column label="变更后可提现余额" width="140">
              <template slot-scope="scope">
                <div>{{scope.row.number |priceFilterNum}}</div>
              </template>
            </el-table-column>
            <el-table-column label="收支类型">
              <template slot-scope="scope">
                <div>{{scope.row.number || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作人">
              <template slot-scope="scope">
                <div>{{scope.row.number || '--'}}</div>
              </template>
            </el-table-column>
          </el-table>
          </div>
        <div class="pagination">
       <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
        </div>
    </div>
    </div>
  </el-drawer>
</template>
<script>

import pagination from '@/components/pagination'

export default {
  components: {
    pagination
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 30,
      total: 0,
      drawer: false,
      list: [],
      rows: '',
      tableHeight: window.innerHeight - 380,
      loadingTable: false,
      type: ''
    }
  },
  methods: {
    // 报缺侧边栏初始化
    onInitialize(type, row) {
      this.rows = row
      this.drawer = true
      this.type = type
      if (this.type === 1) { // 客户
      } else { // 供应商
      }
    },

    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 关闭
    close() {
      this.drawer = false
    },
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style  lang="scss" scoped>
.boxHeight {
  height: 200px;
}
h5,
h4 {
  text-align: center !important;
}
h5 {
  margin: 0px !important;
  font-size: 14px;
}
.join-inquiry-list-drawer {
  padding: 20px;
  font-size: 14px !important;
  .join-inquier-list-crumbs {
    padding-left: 20px;
    font-size: 14px;
    span:first-child {
      padding-right: 10px;
    }
  }
  .join-inquier-list-product {
    padding: 30px 0 0 0px;
    .item-box-add {
      margin: 0 0 30px 0;
      .title-font-style {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 16px;
      }
      .serial_list {
        border: 1px solid #ebeef6;
        height: 500px;
        margin-top: 15px;
        width: 100%;
        display: flex;
        align-content: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        .serial_list_item {
          border-right: 1px solid #ebeef6;
          border-bottom: 1px solid #ebeef6;
          width: 16.5%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          &:nth-child(6n) {
            border-right: none;
          }
        }
      }
    }
  }
  .dialog-footer {
    width: 180px;
    margin: 30px auto;
    float: right;
  }
}
</style>
